var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeycardActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 1,
    id: "_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.8,399.43H114.47A60.4,60.4,0,0,1,54.13,339.1V175.2a60.4,60.4,0,0,1,60.34-60.33H395.8a60.39,60.39,0,0,1,60.33,60.33V339.1A60.39,60.39,0,0,1,395.8,399.43ZM114.47,144.87A30.37,30.37,0,0,0,84.13,175.2V339.1a30.37,30.37,0,0,0,30.34,30.33H395.8a30.36,30.36,0,0,0,30.33-30.33V175.2a30.36,30.36,0,0,0-30.33-30.33Z",
    fill: "#59A3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.13,267.72h-372a15,15,0,0,1-15-15V190.83a15,15,0,0,1,15-15h372a15,15,0,0,1,15,15v61.89A15,15,0,0,1,441.13,267.72Zm-357-30h342V205.83h-342Z",
    fill: "#59A3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.79,316H115.56a15,15,0,0,1,0-30h38.23a15,15,0,0,1,0,30Z",
    fill: "#59A3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.29,316H193.06a15,15,0,0,1,0-30h38.23a15,15,0,0,1,0,30Z",
    fill: "#59A3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.79,316H270.56a15,15,0,1,1,0-30h38.23a15,15,0,0,1,0,30Z",
    fill: "#59A3CF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycardActive);
export default __webpack_public_path__ + "static/media/keycard-active.e6e6cc3567c48f8fa9df00f3aba52b46.svg";
export { ForwardRef as ReactComponent };